import { render, staticRenderFns } from "./500.vue?vue&type=template&id=8212ef74&lang=pug&"
var script = {}
import style0 from "./500.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports